export const LIST_FIELDS = [
    'id',
    'name',
    'address',
    'city',
    'postcode',
    'action_type',
    'custom_region',
    'custom_zone',
    'custom_sector',
];

export const BDD_COLUMNS = {
    '1': 'custom_region',
    '2': 'custom_zone',
    '3': 'custom_sector',
};

export const BASE_SECTO = {
    id: 0,
    shop: 0,
    name: '',
    postcode: '',
    address: '',
    city: '',
    action_type: '',
    region_id: '',
    zone: '',
    sector: '',
    region: '',
    td_linx: '',
    code_lsa: '',
    code_bb: '',
    code_liva: '',
    customs: [],
    manager_sector: [],
    manager_zone: [],
    manager_region: [],
};
